var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.874,
    height: 16.874,
    viewBox: "0 0 16.874 16.874",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25987"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14891",
    d: "M10878.791 498.659h-13.6l-.637-.829h-.431v9.894l1.752 1.033h13.188v-3.781l-4.191-.115-1.037-1.441.5-1.45 3.878-.374.85-.515z",
    transform: "translate(-10864.014 -492.078)",
    style: {
      fill: "#612166"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14877",
    d: "M15.749 7.594h-.562v-4.5a.281.281 0 0 0-.281-.281H13.2l-.559-1.772a.281.281 0 0 0-.369-.178l-2.29.873L8.955.13a.281.281 0 0 0-.178-.123.275.275 0 0 0-.213.039L4.342 2.813H1.969A1.971 1.971 0 0 0 0 4.782v10.124a1.971 1.971 0 0 0 1.969 1.969h12.936a.281.281 0 0 0 .281-.281v-3.375h.562a1.125 1.125 0 0 0 1.125-1.125V8.719a1.125 1.125 0 0 0-1.124-1.125zm0 .562a.563.563 0 1 1 0 1.125h-.562V8.156zm-1.125-4.78v2.812h-.356l-.888-2.812zm-.946 2.812h-.82l-.78-2.339a.281.281 0 0 0-.267-.192 1.069 1.069 0 0 1-.761-.315l-.165-.165a.281.281 0 0 0-.3-.065L2.268 6.188h-.3a1.4 1.4 0 0 1-1-.417L12.2 1.5zm-1.413 0H3.89L10.616 3.7l.037.038a1.625 1.625 0 0 0 .952.467zM8.634.673l.812 1.268-6.559 2.5zm-6.665 2.7h1.514L.644 5.235a1.388 1.388 0 0 1-.082-.454 1.408 1.408 0 0 1 1.407-1.405zm12.655 12.939H1.969a1.408 1.408 0 0 1-1.406-1.406V6.16l.008.008c.022.022.045.042.068.063s.047.045.072.065l.074.056c.025.018.051.04.078.059s.053.033.08.049.055.035.084.051.058.028.087.042l.086.042c.03.013.064.024.1.035s.056.023.086.031l.108.028.081.021c.027.006.084.014.126.02.024 0 .046.008.07.011a2.011 2.011 0 0 0 .2.01h.366v.011l.03-.011h12.257v2.53h-3.093a1.969 1.969 0 0 0 0 3.937h3.094zm1.687-4.218a.562.562 0 0 1-.563.562h-4.217a1.406 1.406 0 0 1 0-2.812h4.218a1.117 1.117 0 0 0 .2-.021l.048-.01a1.122 1.122 0 0 0 .186-.058h.01a1.114 1.114 0 0 0 .117-.058zm0 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14878",
    d: "M6.067 7.594h1.125v.562H6.067zm0 0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14879",
    d: "M3.817 7.594h1.125v.562H3.817zm0 0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14880",
    d: "M12.816 7.594h.964v.562h-.964zm0 0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14881",
    d: "M10.566 7.594h1.125v.562h-1.125zm0 0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14882",
    d: "m1.637 7.554-.132.546a2 2 0 0 0 .463.056h.723v-.562h-.723a1.446 1.446 0 0 1-.331-.04zm0 0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14883",
    d: "M8.316 7.594h1.125v.562H8.316zm0 0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14884",
    d: "m1.637 14.866-.132.546a2 2 0 0 0 .463.056h.723v-.562h-.723a1.444 1.444 0 0 1-.331-.04zm0 0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14885",
    d: "M12.816 14.906h.964v.563h-.964zm0 0"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14886",
    d: "M6.067 14.906h1.125v.563H6.067zm0 0"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14887",
    d: "M10.566 14.906h1.125v.563h-1.125zm0 0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14888",
    d: "M3.817 14.906h1.125v.563H3.817zm0 0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14889",
    d: "M8.316 14.906h1.125v.563H8.316zm0 0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14890",
    d: "M11.53 10.406a.844.844 0 1 0 .844.844.844.844 0 0 0-.844-.844zm0 1.125a.281.281 0 1 1 .281-.281.281.281 0 0 1-.281.281zm0 0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.360fb42958ad062ddbcd920f500a8e73.svg";
export { ForwardRef as ReactComponent };